@if (matomoConsent.available) {
  @if ((matomoConsent.decision$ | async) === 'unknown' || consentPanelOpen) {
    <section class="matomo-consent" aria-labelledby="matomo-consent-title">
      <h2 id="matomo-consent-title">{{ 'MATOMO_CONSENT.TITLE' | translate }}</h2>
      <p>{{ 'MATOMO_CONSENT.DESCRIPTION' | translate }}</p>
      <div class="matomo-consent__actions">
        <button type="button" (click)="chooseConsent(false)">{{ 'MATOMO_CONSENT.REJECT' | translate }}</button>
        <button type="button" (click)="chooseConsent(true)">{{ 'MATOMO_CONSENT.ACCEPT' | translate }}</button>
        @if ((matomoConsent.decision$ | async) !== 'unknown') {
          <button type="button" (click)="consentPanelOpen = false">{{ 'MATOMO_CONSENT.CLOSE' | translate }}</button>
        }
      </div>
    </section>
  } @else {
    <button type="button" class="matomo-consent-settings" (click)="consentPanelOpen = true">
      {{ 'MATOMO_CONSENT.SETTINGS' | translate }}
    </button>
  }
}
